/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSchoolIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-school"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M21.85 16.38L21.85 10L13.28 14.68Q12.68 15 12 15Q11.32 15 10.72 14.68L1.65 9.7Q1.3 9.5 1.13 9.2Q0.95 8.9 0.95 8.55Q0.95 8.2 1.13 7.9Q1.3 7.6 1.65 7.4L10.72 2.42Q11.03 2.25 11.35 2.17Q11.68 2.1 12 2.1Q12.32 2.1 12.65 2.17Q12.97 2.25 13.28 2.42L23.8 8.18Q24.13 8.35 24.31 8.66Q24.5 8.97 24.5 9.32L24.5 16.38Q24.5 16.93 24.11 17.31Q23.73 17.7 23.18 17.7Q22.63 17.7 22.24 17.31Q21.85 16.93 21.85 16.38ZM10.72 21.52L5.63 18.75Q4.97 18.4 4.61 17.77Q4.25 17.15 4.25 16.43L4.25 12.63L10.72 16.15Q11.32 16.48 12 16.48Q12.68 16.48 13.28 16.15L19.75 12.63L19.75 16.43Q19.75 17.15 19.39 17.77Q19.02 18.4 18.38 18.75L13.28 21.52Q12.97 21.7 12.65 21.76Q12.32 21.82 12 21.82Q11.68 21.82 11.35 21.76Q11.03 21.7 10.72 21.52Z" fill={color} />
    </svg>
  );
}
